import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { generateUuid } from '@core/utils-legacy';
import type { TrackableImageFile } from '@core/wysiwyg-legacy';
import { getImageDimensionsFromFile } from '@core/wysiwyg-legacy';

export const mapToTrackableImageFile = (file: File): Observable<TrackableImageFile> =>
  getImageDimensionsFromFile(file).pipe(
    map(({ width, height, src }) => ({
      id: generateUuid(),
      url: src,
      file,
      width,
      type: 'image',
    })),
  );

export const mapToTrackableImageFiles = (files: File[]): Array<Observable<TrackableImageFile>> =>
  files.map(fileOrData => mapToTrackableImageFile(fileOrData));
